var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('Workspaces'),_c('SideMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }